import {
  Component,
  Input,
} from '@angular/core'
import { HelpCenterService } from '../../services/help-center/help-center.service'

@Component({
  selector: 'help-center-article',
  styleUrls: ['./help-center-article.component.less'],
  templateUrl: './help-center-article.component.html'
})

export class HelpCenterArticleComponent {

  @Input() articleId: number
  article: any

  constructor (
    private helpCenterService: HelpCenterService,
  ) {
  }

  ngAfterViewInit() {
    this.helpCenterService.loadArticle(this.articleId).subscribe(article => {
      this.article = article
    })
  }
}
